import brandPrimaryLogo from 'assets/images/laurel-primary-icon.png'
import MDBox from 'components/MDBox'
import PageLayout from 'modules/LayoutContainers/PageLayout'

function SplashScreen(): JSX.Element {
	return (
		<PageLayout>
			<MDBox
				display={'flex'}
				justifyContent={'center'}
				sx={{
					position: 'absolute', // Makes the box cover the entire screen
					top: 0,
					left: 0,
					minWidth: '100vw',
					minHeight: '100vh',
					'@keyframes pulse': {
						'0%': {
							transform: 'scale(1)',
							opacity: 0.6,
						},
						'50%': {
							transform: 'scale(1.5)',
							opacity: 1,
						},
						'100%': {
							transform: 'scale(1)',
							opacity: 0.6,
						},
					},
				}}
				alignItems={'center'}
				bgColor="grey-500"
			>
				<MDBox
					component="img"
					src={brandPrimaryLogo}
					alt="Brand"
					width="5rem"
					sx={{
						animation: 'pulse 2s infinite', // Use the embedded keyframes
					}}
				/>
			</MDBox>
		</PageLayout>
	)
}

export default SplashScreen
